import React, { useEffect, useState } from 'react';

/**
 * size
 * position
 * onChange(position)
 */
function PaginationBtn({ data }) {
	const [options, setOptions] = useState([]);
	const [position, setPosition] = useState(0);

	useEffect(() => {
		let arr = [];
		for (let i = 0, ii = data.size; i < ii; i++) {
			arr.push(`Page ${i + 1} of ${ii}`);
		}
		setOptions(arr);
	}, [data]);

	function actionPrevious() {
		if (data.position != 0 && data.onChange != undefined) {
			setPosition(data.position - 1);
			data.onChange(data.position - 1);
		}
	}

	function actionNext() {
		let pos = data.position + 1;
		if (pos !== data.size && data.onChange != undefined) {
			setPosition(pos);
			data.onChange(pos);
		}
	}

	function actionSkip(e) {
		let pos = parseInt(e.target.value);
		setPosition(pos);
		data.onChange(pos);
	}

	return (
		<div style={{ padding: '30px 0' }}>
			<section className='btn-group'>
				<button type='button' onClick={actionPrevious}>
					Previous
				</button>
				<select onChange={actionSkip} value={position}>
					{options.map((str, index) => (
						<option key={str} value={index}>
							{str}
						</option>
					))}
				</select>
				<button type='button' onClick={actionNext}>
					Next
				</button>
			</section>
		</div>
	);
}

export default React.memo(PaginationBtn);
